import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "ring" }, null, -1 /* HOISTED */)

const componentName = 'Hotspot';
interface Window {
	dataLayer?: any[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Hotspot',
  props: {
	leftPositionX: {
		type: String,
		default: "0"
	},
	topPositionY: {
		type: String,
		default: '0'
	},
	displayTitle: {
		type: String,
		default: ''
	},
	modalVisible: {
		type: Boolean,
		default: false
	},
	color: {
		type: String,
		default: ''
	},
	hotspotPlacementsLength: {
		type: Number,
		default: 0
	},
	index: {
		type: Number,
		default: 0
	},
	hotspots: {
		type: Array as () => any[],
		default: []
	}
},
  emits: ['modalVisibilityUpdated', 'updateActiveHotspotIndex'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;

const launchModal = () => {
	emit('updateActiveHotspotIndex', props.index);
	emit('modalVisibilityUpdated', true);

	// Assert the type of window.dataLayer
	//@ts-ignore
	const dataLayer = window.dataLayer as any[];

	// Now TypeScript knows that dataLayer is an array and push method can be called on it
	dataLayer.push({
		'hotspotLeft': props.leftPositionX,
		'hotspotTop': props.topPositionY,
		'hotspotScene': props.displayTitle,
		'hotspotDisplayTitle': props.hotspots[0]?.DisplayTitle,
		'hotspotPage': `${props.index + 1} of ${props.hotspotPlacementsLength}`,
		'event': 'Click Hotspot'
	});
}
const closeModal = () => {
	emit('modalVisibilityUpdated', false);
}
const modalVisibilityUpdated = (value) => {
	emit('modalVisibilityUpdated', value);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "hotspot-scene__hotspot-circle-trigger animate__animated animate__delay-1s animate__fadeIn",
    style: _normalizeStyle(`left: ${__props.leftPositionX}%; top: ${__props.topPositionY}%;`),
    onClick: launchModal
  }, [
    _hoisted_1,
    _createElementVNode("span", {
      class: "circle",
      style: _normalizeStyle(`background-color: ${__props.color}`)
    }, null, 4 /* STYLE */)
  ], 4 /* STYLE */))
}
}

})